import {Component, OnInit, Input, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {ApiService} from "../../../../services/api.service";
import {UserService} from "../../services/users.service";
import {HttpErrorResponse} from "@angular/common/http";
import {
  StPagination2Component
} from "../../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {PageChangeDto} from "../../../../models/page-change-dto";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-wishlist-listing',
  templateUrl: './wishlist-listing.component.html',
  styleUrls: ['./wishlist-listing.component.scss'],
  standalone: false
})
export class WishListListingComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Wishlist'}
  ];

  @Input()
  rows: any[] = [];

  @Input()
  loadingData: boolean = false;

  username: string = '';
  userId: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;

  @ViewChild('feedbackpaginator') stPaginator2Component!: StPagination2Component;
  page: number = 0;
  collectionSize: number = 0;
  pageSize: number = 15;
  customPageSizes = [
    {
      "pageSizeId" : 5,
      "pageSize": 5
    }, {
      "pageSizeId" : 10,
      "pageSize": 10
    },{
      "pageSizeId" : 15,
      "pageSize": 15
    }, {
      "pageSizeId" : 25,
      "pageSize": 25
    }, {
      "pageSizeId" : 50,
      "pageSize": 50
    }
  ];

  //Needs pop up for Wishlist Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService: UserService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy All Wishlist Entries");
  }

  ngOnInit(): void {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    if (this.username) {
      this.userService.getAllWishlistEntriesByUser(this.username, 1, this.pageSize, this.impersonatedEmail)
        .subscribe((result : any) => {
        if (result && result.body) {
          this.rows = result.body.dtos;
          this.page = 1
          this.collectionSize = result.body.collectionSize
          this.stPaginator2Component.initPages(this.collectionSize, this.pageSize)
        }
      }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Get Wishlist API Failure',
            detail: 'Failed to pull wishlist...',
            severity: 'error'
          });
          this.showErrorMessagesToUser();
      });
    } else {
      this.routerChild.navigateByUrl('/app/login')
    }
  }

  changePageResults(pageChangeDto: PageChangeDto): void {
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.pageSize = pageChangeDto["pageSize"]
    }
    this.userService.getAllWishlistEntriesByUser(this.username, updatePageValue, this.pageSize, this.impersonatedEmail)
      .subscribe((result : any) => {
        if (result && result.body) {
          this.rows = result.body.dtos;
          this.page = updatePageValue
          this.collectionSize = result.body.collectionSize
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Get Wishlist API Failure',
          detail: 'Failed to pull wishlist entries...',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      })
  }

  onCreateWishlistEntry(): void {
    this.routerChild.navigateByUrl('/app/users/dashboard/wishlist-home/wishlist/create');
  }

  onCancel(): void {
    this.routerChild.navigateByUrl('/app/users/dashboard');
  }

  onViewDetails(row: any) {
    this.routerChild.navigateByUrl(`/app/users/dashboard/wishlist-home/wishlist/${row.feedbackId}/view`);
  }

}
